import React from 'react'
import PropTypes from 'prop-types'

import { onEnterOrSpace } from '../../../utils/key-handler'

import './Checkbox.css'

const Checkbox = ({
  onSelect,
  field: { name, value, onChange, onBlur },
  form: { errors, touched, setFieldValue, setFieldTouched },
  disabled,
  id,
  label,
  ...props
}) => {
  return (
    <div data-testid='checkbox-full' styleName='inputGroup'>
      <input
        data-testid='checkbox-input'
        styleName='input'
        name={name}
        id={id}
        type='checkbox'
        value={value}
        checked={value}
        onChange={(...a) => {
          if (onSelect) {
            onSelect(...a)
            return
          }
          setFieldTouched(name, true)
          onChange(...a)
        }}
        onBlur={onBlur}
        disabled={disabled}
        {...props}
      />
      <label data-testid='checkbox-data' styleName='label' tabIndex='0' onKeyDown={
        onEnterOrSpace(() => {
          if (!disabled) {
            if (onSelect) {
              onSelect()
              return
            }
            setFieldValue(name, !value)
          }
        })
      } htmlFor={id}>
        {label}
      </label>
    </div>
  )
}

const FormShape = PropTypes.shape({
  errors: PropTypes.object,
  touched: PropTypes.object,
  setFieldValue: PropTypes.func
})

const FieldShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
})

Checkbox.propTypes = {
  field: FieldShape.isRequired,
  form: FormShape.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  onSelect: PropTypes.func
}

export default Checkbox
